import React from "react";
import { CircularProgress, Box } from "@mui/material";

// Custom Spinner component to replace @deere/ux.uxframe-react Spinner
const Spinner = ({ size = 40, className = "", color = '#367c2b', ...props }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      className={className}
      {...props}
    >
      <CircularProgress
        size={size}
        sx={{
          color: color
          // Or if you want to use your John Deere colors:
          // color: '#367c2b', // John Deere Green
          // color: '#FFDE00', // John Deere Yellow
        }}
      />
    </Box>
  );
};

export default Spinner;
